export const socialsData = {
    github: 'https://github.com/praveenmistry',
    linkedIn: 'https://in.linkedin.com/in/praveen-kumar-suthar-890599a2',
    instagram: 'https://www.instagram.com/pmistry_',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    blogger: 'https://leet-codes.blogspot.com',
    medium: 'https://medium.com/@praveenmistry/',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}